<div [ngClass]="{ 'oculto' : dataSource.data.length == 0 }">

    <table mat-table [dataSource]="dataSource" multiTemplateDataRows
       class="mat-elevation-z8">

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="th-title">
                Acción
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
                <span>{{ element.name }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="resolutionComment">
            <th mat-header-cell *matHeaderCellDef class="th-title">
                Resolución
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
                <span>{{ element.resolutionComment }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="th-title">
                Estado
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1" style="font-weight: bold;">
                <span *ngIf="element.status==0">Pendiente</span>
                <span *ngIf="element.status==1" style="color: green;">Aprobado</span> 
                <span *ngIf="element.status==2" style="color: red;">Rechazado</span> 
                <span *ngIf="element.status==3" style="color: #b2b505">Falta Informacion</span> 
            </td>
        </ng-container>

        <ng-container matColumnDef="creationDate">
            <th mat-header-cell *matHeaderCellDef class="th-title">
                Fecha
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
                <span>{{ element.creationDate | date : 'dd/MM/yyyy' }} - {{ element.creationDate | date: 'HH:mm' }}Hrs.</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="requestingUser">
            <th mat-header-cell *matHeaderCellDef class="th-title">
                Ejecutivo
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
                <span>{{ element.requestingUser }}</span>
            </td>
        </ng-container>

        <ng-container matColumnDef="tags">
            <th mat-header-cell *matHeaderCellDef class="th-title">
                Etiqueta/s
            </th>
            <td mat-cell *matCellDef="let element" class="mat-body-1">
                <span *ngFor="let tag of element.tags">
                    <mat-chip style="font-size:smaller; font-weight: bold; background-color: rgba(18, 79, 211, 0.385);">{{ tag }}</mat-chip>
                </span>
                <span *ngIf="element.tags.length==0">
                    <mat-chip style="font-size:smaller; font-weight: bold; background-color: rgba(172, 177, 188, 0.385);"> S/N</mat-chip>
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="expand">
            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
            <td mat-cell *matCellDef="let element">
            <button mat-icon-button aria-label="expand row"
                    (click)="expandedElement = expandedElement === element ? null : element; $event.stopPropagation()">
                <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon>
                <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
            </button>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
            <div class="example-element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">

                <div class="example-element-description" style="width: 100%;">

                    <div [ngClass]="{ 'oculto' : element.actionLogs.length != 0 }" style="text-align: center;">
                        <h4>Sin Acciones</h4>
                    </div>

                    <table mat-table [dataSource]="element.actionLogs" class="mat-elevation-z8" [ngClass]="{ 'oculto' : element.actionLogs.length == 0 }" style="text-align: center;">

                        <ng-container matColumnDef="creationLog">
                            <th mat-header-cell *matHeaderCellDef class="th-title"> Fecha </th>
                            <td mat-cell *matCellDef="let log" class="mat-body-1"> <span>{{ log.creationLog | date : 'dd/MM/yyyy' }} - {{ log.creationLog | date: 'HH:mm' }}Hrs.</span> </td>
                        </ng-container>
                        
                        <ng-container matColumnDef="userName">
                            <th mat-header-cell *matHeaderCellDef class="th-title"> Usuario </th>
                            <td mat-cell *matCellDef="let log" class="mat-body-1"> <span>{{ log.userName }}</span> </td>
                        </ng-container>

                        <ng-container matColumnDef="comment">
                            <th mat-header-cell *matHeaderCellDef class="th-title"> Comentario </th>
                            <td mat-cell *matCellDef="let log" class="mat-body-1"> <span>{{ log.comment }}</span> </td>
                        </ng-container>
                        
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="th-title"> Estado </th>
                            <td mat-cell *matCellDef="let log" class="mat-body-1" style="font-weight: bold;">
                                <span *ngIf="log.status==0">Pendiente</span>
                                <span *ngIf="log.status==1" style="color: green;">Aprobado</span> 
                                <span *ngIf="log.status==2" style="color: red;">Rechazado</span> 
                                <span *ngIf="log.status==3" style="color: #b2b505">Requiere Informacion</span> 
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="['creationLog', 'userName', 'comment', 'status']"></tr>
                        <tr mat-row *matRowDef="let log; columns: ['creationLog', 'userName', 'comment', 'status']" class="cursor-table"></tr>
                    </table>
                </div>
                
            </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
        <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand" [cdkContextMenuTriggerFor]="menu"
            class="example-element-row cursor-table"
            [class.example-expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element">

            <ng-template #menu>
                <div cdkMenu class="context_menu mat-elevation-z0" style="z-index: 999">
                <span>
                    <button style="margin-bottom: 5px;"
                    class="context-menu-item"
                    cdkMenuItem
                    mat-flat-button
                    (click)="openModalNewActiviti(element)"
                    >
                    Actualizar Estado
                    </button> <br>
                    </span>
                <span>
                    <button
                    class="context-menu-item"
                    cdkMenuItem
                    mat-flat-button
                    (click)="abrirModalTags(element)"
                    >
                    Editar Etiqueta/s
                    </button>
                </span>
                </div>
            </ng-template>

        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row">
        </tr>
    </table>

</div>

<div [ngClass]="{ 'oculto' : dataSource.data.length > 0 }" style="text-align: center;">

    <h2>No se encontro actividad sobre el trato</h2>

</div>